import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { ServerOption } from '../../server/models/server-option';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { serverOptionActions } from '../state/server-option.actions';
import { serverOptionSelectors } from '../state/server-option.reducer';

@Directive({
    selector: '[ndtServerSelect]',
    standalone: false
})
export class ServerSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<ServerOption>,
      private statusService: NgrxEagerSelectService<AppState, ServerOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] | undefined;

      if (this.accountId) {
         staticFilterOverride = [`AccountId = ${this.accountId}`];
      }
      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            serverOptionActions,
            serverOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('serverId', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
